import GoodToKnowSection from 'components/GoodToKnowSection';
import Link from 'next/link';
import { getCta } from 'utils/common';
import { colors } from 'utils/constants';

export const ResultsGoodToKnow = () => {
  return (
    <div
      className="fullWidth flexCentered"
      style={{ background: colors.footerBackground }}
    >
      <GoodToKnowSection style={{ margin: '4em auto' }}>
        <>
          <h2>How to enter DAYMADE's online competition</h2>

          <p>
            It’s easy to{' '}
            <Link href={getCta()!.url}>
              <a>enter</a>
            </Link>{' '}
            our online competition. All you have to do is select how many weekly
            entries you’d like to play and choose your numbers - after that,
            you’re ready to go! Watch us draw out the winning lotto numbers
            every Friday at 5pm.
          </p>
        </>

        <>
          <h2>How our competition results work</h2>

          <p>
            Matched a few numbers? Great! Let’s look at how our online
            competition results translate into prizes. Matching just a single
            number can get you a token that you can use to play more with
            DAYMADE. The more numbers you match, the bigger the prize, with five
            main numbers and the bonus ball getting you the jackpot! Learn more
            about{' '}
            <Link href="/how-it-works">
              <a>how it works</a>
            </Link>
            .
          </p>

          <p>
            We even run a{' '}
            <Link href="/token-town/free-daily-draw">
              <a>free daily draw</a>
            </Link>
            . The chances of winning aren’t as good, but what do you have to
            lose?
          </p>
        </>

        <>
          <h2>What are the prizes for having winning numbers?</h2>

          <p>
            If you’re lucky enough to have winning numbers, you can guarantee an
            epic prize. Think luxury getaways with your best friend, shopping
            sprees at your favourite brands, £25k to spend on a year’s worth of
            holidays and so much more. From once in a lifetime{' '}
            <Link href="/prizes/trips-and-stays">
              <a>holidays</a>
            </Link>{' '}
            and{' '}
            <Link href="/prizes/experiences">
              <a>experiences</a>
            </Link>{' '}
            to the latest{' '}
            <Link href="/prizes/tech">
              <a>technology</a>
            </Link>{' '}
            and{' '}
            <Link href="/prizes/lifestyle-and-beauty">
              <a>lifestyle and beauty prizes</a>
            </Link>
            , we have it all: don’t miss your chance to win! View{' '}
            <Link href="/prizes">
              <a>all our prizes</a>
            </Link>
            .
          </p>
        </>

        <>
          <h2>Why play with DAYMADE?</h2>

          <p>
            Whether you pick the winning numbers or not, there are plenty of
            reasons to play with DAYMADE. We believe in{' '}
            <Link href="/giving-back">
              <a>giving back</a>
            </Link>
            , so for every purchase, we plant a tree in Kwale County (Kenya)
            with the amazing organization veritree. Offering a climate change
            solution by planting verifiable trees, veritree carry out incredible
            work, and we’re proud that our players are contributing to such an
            important cause.
          </p>

          <p>
            Our players are vital to everything we do, so we’re always looking
            for ways to improve their experience. We have a rewards system where
            you can gain points when you refer friends, suggest prizes and enter
            competitions, so sign up today and make the most of it! Learn more{' '}
            <Link href="/about-us">
              <a>about us</a>
            </Link>
            , and read our{' '}
            <Link href="/blog">
              <a>blog</a>
            </Link>{' '}
            for updates, highlights and tips!
          </p>
        </>
      </GoodToKnowSection>
    </div>
  );
};
